module.exports = __webpack_public_path__ + "img/Learn_English_1.edf5c6af.jpg";